import React from 'react';
import { motion } from 'framer-motion';
import { Headphones, Mic, Radio, Zap, Disc, Music4 } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <Headphones className="w-6 h-6" data-id="element-1" />,
    title: 'Immersive Audio',
    description: '3D spatial audio that puts you inside the music.'
  }, {
    icon: <Zap className="w-6 h-6" data-id="element-2" />,
    title: 'Haptic Sync',
    description: 'Feel every bass drop with controller vibration mapping.'
  }, {
    icon: <Disc className="w-6 h-6" data-id="element-3" />,
    title: 'Vinyl Mode',
    description: 'Classic scratching mechanics for the purists.'
  }, {
    icon: <Mic className="w-6 h-6" data-id="element-4" />,
    title: 'Vocal Battle',
    description: 'Real-time pitch detection for rap and singing battles.'
  }, {
    icon: <Radio className="w-6 h-6" data-id="element-5" />,
    title: 'Live Stations',
    description: 'Compete in real-time global tournaments.'
  }, {
    icon: <Music4 className="w-6 h-6" data-id="element-6" />,
    title: 'Stem Separation',
    description: 'Isolate drums, vocals, or bass to practice specific parts.'
  }];
  return <section id="features" className="py-24 bg-surface relative" data-id="element-7">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8">
        <div className="text-center mb-16" data-id="element-9">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6" data-id="element-10">
            THE <span className="text-neon-amber" data-id="element-11">TRACKLIST</span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-12">
            Features designed for the audiophile gamer.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-13">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-background p-6 rounded-lg border border-white/5 hover:border-neon-amber/50 transition-all group hover:-translate-y-1" data-id="element-14">
              <div className="w-12 h-12 bg-surface rounded-lg flex items-center justify-center mb-4 text-neon-amber group-hover:text-white group-hover:bg-neon-amber transition-colors" data-id="element-15">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-2 font-display" data-id="element-16">
                {feature.title}
              </h3>
              <p className="text-gray-400 text-sm" data-id="element-17">{feature.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}